import React, { FunctionComponent } from "react"
import HRRService from "src/pages/hr_reports/utils/HRRService"
import ReportTypes from "src/pages/hr_reports/types/ReportTypes"
import "./HRRReportsTableBodyContextMenu.css"
import { OverlayTrigger } from "react-bootstrap"

interface Props {
    id: string
    report: ReportTypes
}

const HRRReportsTableBodyContextMenu: FunctionComponent<Props> = (props) => {

    const { id, report } = props
    const { manageState, HRRServiceTooltip } = HRRService

    return (
        <div id={id} className="HRRReportsTableBodyContextMenu">
            {/*@ts-ignore*/}
            <OverlayTrigger placement="left" overlay={HRRServiceTooltip(report?.description)}>
                <span className="material-icons HRRReportsTableBodyContextMenuInfoSpan">info</span>
            </OverlayTrigger>
            <OverlayTrigger placement="left" overlay={HRRServiceTooltip("Run report")}>
                <span
                    className="material-icons HRRReportsTableBodyContextMenuRunSpan"
                    onClick={() => manageState([{ key: "selectedReport", value: report }])}
                >
                    play_arrow
                </span>
            </OverlayTrigger>
        </div>
    )
}

export default HRRReportsTableBodyContextMenu